import { instance2 } from './base';

export interface Agreement {
    id: string;
    name: string;
    url: string | null;
    is_required: boolean;
    version: string;
    content: string | null;
}

export interface AgreementResponse {
    data: Agreement;
}

export const getPrivacyPolicy = (signal?: AbortSignal): Promise<AgreementResponse> => {
    const config: { signal?: AbortSignal } = {};
    if (signal) {
        config.signal = signal;
    }

    return (instance2 as any)
        .get('/api/v1/agreements/privacy-policy', config)
        .then((response: { data: AgreementResponse }): AgreementResponse => {
            return response.data;
        })
        .catch((error: unknown): never => {
            throw error;
        });
};

export const getTermsAndConditions = (signal?: AbortSignal): Promise<AgreementResponse> => {
    const config: { signal?: AbortSignal } = {};
    if (signal) {
        config.signal = signal;
    }

    return (instance2 as any)
        .get('/api/v1/agreements/tnc', config)
        .then((response: { data: AgreementResponse }): AgreementResponse => {
            return response.data;
        })
        .catch((error: unknown): never => {
            throw error;
        });
};
